export default "__VITE_ASSET__DX04XqWh__"